import React, { useState, useEffect, useMemo, useContext } from "react";
import { useQuery } from "@apollo/client";
import {
  GET_LEAD_DETAILS,
  GET_LEAD_ACTIVITY,
  CURRENT_USER_PROFIILE,
  GET_FLS_DETAIILS,
  FLS_OVERVIEW,
  USER_PROFILE,
} from "../services/userApi";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "./breadcrumb";
import BackButton from "../reusableField/BackButton";
import { Phone, Mail, ClipboardList, ArrowUpRight, Pin } from "lucide-react";
import "../Home/global.css";
import { RoleContext } from "../reusableField/roleContext";

const FlsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = location.state?.returnPage || 1;
  const { roleId } = useContext(RoleContext);

  const flsId = location.state?.flsId;
  const jobRoleId = location.state?.jobRoleId;
  const accountId = location.state?.accountId;

  const { data: userData, loading: userLoadding, error: userError } = useQuery(USER_PROFILE, {
    variables: { userId: flsId },
  });

  const breadcrumbItems = [
    {
      label: "Users",
      href: "/fls",
      onClick: () =>
        navigate("/fls", {
          state: {
            returnPage: currentPage,
            // returnSearchTerm: returnSearchTerm,
          },
        }),
    },
    { label: "User Profile", href: "/fls/flsprofile" },
  ];

  const roleStartDate = userData?.userProfile?.joiningDate;

  const today = useMemo(() => new Date().toISOString(), []);

  const firstDateOfMonthUTC = useMemo(() => {
    const now = new Date();
    return new Date(
      Date.UTC(now.getFullYear(), now.getMonth(), 1)
    ).toISOString();
  }, []);

  const { data: overviewTotalData } = useQuery(FLS_OVERVIEW, {
    variables: {
      startDate: roleStartDate,
      endDate: today,
      userId: flsId,
    },
    skip: !flsId || !roleStartDate,
  });

  const { data: overviewMonthData } = useQuery(FLS_OVERVIEW, {
    variables: {
      startDate: firstDateOfMonthUTC,
      endDate: today,
      userId: flsId,
    },
    skip: !flsId || !roleStartDate,
  });

  const getInitials = (name) => {
    if (!name || name === "N/A") return "NA";
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  const getFlsUserDetails = () => {
    if (!userData?.userProfile || !flsId) {
      return null;
    }

    return userData.userProfile
  };

  const TotalLeads = ({ data }) => {
    return (
      <div className="flex justify-between items-center p-5 bg-white rounded-xl shadow-md border border-gray-200 w-[350px]">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-gray-700 font-medium">Total Leads</h3>
          </div>

          <h1 className="text-4xl font-bold text-[#1ABC9C] mt-2">
            {data?.getLeadsCountAssignedToUser}
          </h1>

          <h3 className="text-gray-500 text-sm mt-1">Since Joined</h3>
        </div>

        <div className="text-teal-300">
          <ClipboardList className="w-12 h-12" />
        </div>
      </div>
    );
  };

  const MonthLeads = ({ data }) => {
    return (
      <div className="flex justify-between items-center p-5 bg-white rounded-xl shadow-md border border-gray-200 w-[350px]">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-gray-700 font-medium">Leads Assigned</h3>
          </div>

          <h1 className="text-4xl font-bold text-[#1ABC9C] mt-2">
            {data?.getLeadsCountAssignedToUser}
          </h1>

          <h3 className="text-gray-500 text-sm mt-1">In Current Month</h3>
        </div>

        <div className="text-teal-300">
          <Pin className="w-12 h-12" />
        </div>
      </div>
    );
  };
  const flsUserDetails = getFlsUserDetails();
  const fullName = flsUserDetails?.name || "N/A";

  return (
    <div className="mt-[85px] ml-[75px] p-4 min-h-screen bg-[#f4f4f4] global">
      {userLoadding ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#dc3545]"></div>
          <p className="ml-3 text-gray-600">Loading</p>
        </div>
      ) : userError ? (
        <p>Error loading FLS details.</p>
      ) : (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "4px" }}>
            <BackButton label="Back" />
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-6">
            <div className="flex items-center justify-between">
              <div className="flex items-start gap-4">
                <div className="w-20 h-20 primary rounded-lg flex items-center justify-center text-white text-2xl font-semibold flex-shrink-0">
                  {getInitials(fullName)}
                </div>

                <div className="flex-1">
                  <h1 className="text-2xl font-semibold text-gray-900 mb-2">
                    {fullName}
                  </h1>

                  <div className="space-y-2 text-base text-gray-600">
                    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 custom:gap-20">
                      <div className="flex items-center gap-2 ">
                        <span className="font-medium">Employee Id:</span>
                        <span>
                          {flsUserDetails?.employeeId || "Not Assigned"}
                        </span>
                      </div>

                      <div className="flex items-center gap-2">
                        <span className="font-medium">City:</span>
                        <span>{flsUserDetails?.cityName || "N/A"}</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <span className="font-medium">State:</span>
                        <span>{flsUserDetails?.stateName || "N/A"}</span>
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <Phone className="w-4 h-4 " />
                      <span>{flsUserDetails?.phoneNumber}</span>
                    </div>

                    <div className="flex items-start gap-2">
                      <Mail className="w-4 h-4 mt-2" />
                      <span>{flsUserDetails?.email}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Section - Status Badge */}
              <div className="flex flex-col items-end">
                <div className="primary text-white px-4 py-3 rounded-lg text-center min-w-[140px]">
                  <div className="text-sm font-medium">Date of Joining</div>
                  <div className="text-lg font-bold mt-1">
                    {flsUserDetails?.joiningDate}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-6">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-[#393939] mb-2">
                Overview
              </h2>
              <div className="flex flex-wrap gap-20 justify-between:items-center">
                <TotalLeads data={overviewTotalData} />
                <MonthLeads data={overviewMonthData} />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FlsDetails;
